import React from "react";
import { default as MuiContainer } from "@mui/material/Container";

function Container(props) {
  return <MuiContainer {...props} />;
}

export default Container;
